import { useRef } from "react";

import { createSubmitGuard, type SubmitGuard } from "@/lib/submit-guard";

// Holds one SubmitGuard instance for the component's lifetime so begin()/end()
// share in-flight state across renders and across the VGS callbacks. The
// returned object is referentially stable, so callbacks that close over it do
// not need to re-create when it appears in their dependency arrays.
export function useSubmitGuard(): SubmitGuard {
  const ref = useRef<SubmitGuard | null>(null);
  if (ref.current === null) {
    ref.current = createSubmitGuard();
  }
  return ref.current;
}
